import axiosClientFSR from "../axiosClientFSR";

export const streamFSR = {
    postListCodeCam: (data) => {
        return axiosClientFSR.post(`/stream`, data)
    }
}